import { Component } from '@angular/core';
import { context } from 'bookingbug-core-js';
import { AppConfig } from './app.config';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { DatastoreService } from './services/datastore.service';
import { AlertModule, AlertService } from './_alert';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SkipToContentComponent } from './skip-to-content/skip-to-content.component';
import { HeaderComponent } from './header/header/header.component';
import { FooterComponent } from './footer/footer/footer.component';
import { MemberBarComponent } from './member-bar/member-bar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgxSpinnerModule,
    TranslateModule,
    SkipToContentComponent,
    HeaderComponent,
    FooterComponent,
    MemberBarComponent,
    AlertModule,
  ],
})
export class AppComponent {
  title = 'Kent HWRC';
  loadIssue: boolean;

  constructor(
    private translate: TranslateService,
    private DataStore: DatastoreService,
    private alertService: AlertService
  ) {
    translate.setDefaultLang('en');

    this.DataStore.notify.subscribe((result) => {
      this.loadIssue = result;
      this.scrollToTop();
      this.alertService.clear();
      this.alertService.error(this.translate.instant('COMMON.LOAD_ISSUE'));
    });
  }

  ngOnInit() {
    // BB Context storage
    context.apiUrl = AppConfig.settings.apiServer.api_url;
    context.apiVersion = AppConfig.settings.apiServer.version;
    context.appId = AppConfig.settings.core.app_id;
    context.appKey = AppConfig.settings.core.app_key;
    // storage event to modify localStorage
    //   window.addEventListener('storage', (event) => {
    //     if (event.storageArea == localStorage) {
    //          let token = localStorage.getItem('token_name');
    //          if(token == undefined) {
    //            // Perform logout
    //            //Navigate to homepage
    //             this.router.navigate(['/departments']);
    //          }
    //     }
    // });
    // }
  }

  scrollToTop() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);
  }
}


